function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
var ListItemName = 'listItem';
var TextStyleName = 'textStyle';
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */

var inputRegex = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */

var OrderedList = Node.create({
  name: 'orderedList',
  addOptions: function addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: 'block list',
  content: function content() {
    return "".concat(this.options.itemTypeName, "+");
  },
  addAttributes: function addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: function parseHTML(element) {
          return element.hasAttribute('start') ? parseInt(element.getAttribute('start') || '', 10) : 1;
        }
      },
      type: {
        default: undefined,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('type');
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'ol'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;

    var start = HTMLAttributes.start,
        attributesWithoutStart = _objectWithoutProperties(HTMLAttributes, ["start"]);

    return start === 1 ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0] : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      toggleOrderedList: function toggleOrderedList() {
        return function (_ref2) {
          var commands = _ref2.commands,
              chain = _ref2.chain;

          if (_this.options.keepAttributes) {
            return chain().toggleList(_this.name, _this.options.itemTypeName, _this.options.keepMarks).updateAttributes(ListItemName, _this.editor.getAttributes(TextStyleName)).run();
          }

          return commands.toggleList(_this.name, _this.options.itemTypeName, _this.options.keepMarks);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-7': function ModShift7() {
        return _this2.editor.commands.toggleOrderedList();
      }
    };
  },
  addInputRules: function addInputRules() {
    var _this3 = this;

    var inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        return {
          start: +match[1]
        };
      },
      joinPredicate: function joinPredicate(match, node) {
        return node.childCount + node.attrs.start === +match[1];
      }
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: function getAttributes(match) {
          return _objectSpread({
            start: +match[1]
          }, _this3.editor.getAttributes(TextStyleName));
        },
        joinPredicate: function joinPredicate(match, node) {
          return node.childCount + node.attrs.start === +match[1];
        },
        editor: this.editor
      });
    }

    return [inputRule];
  }
});
export { OrderedList, OrderedList as default, inputRegex };